module.exports = __webpack_public_path__ + "img/bne2.b97e6e37.jpg";